import {AfterViewInit, Directive, EventEmitter, Output,} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';

@Directive({
    selector: '[appStepperWatcher]'
})
export class StepperWatcherDirective implements AfterViewInit {
    @Output() stepsChanged: EventEmitter<number> = new EventEmitter<number>();

    constructor(private matStepper: MatStepper) {
    }

    ngAfterViewInit(): void {
        const stepper = this.matStepper;
        if (stepper && stepper._stepHeader) {
            this.stepsChanged.emit(stepper.steps.length);

            stepper.steps.changes.subscribe((r) => {
                this.stepsChanged.emit(r.length);
            });
        }
    }
}
